import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import PolicyLayout, { PolicySection } from "@/components/common/PolicyLayout";
import { Link } from "@/components/common/Link";
export default function ShippingPage() {
  return <div>
      <Header />
      <PolicyLayout title="Shipping Policy" intro="Information regarding our shipping coverage, flat-rate costs, delivery processes, and receipt inspection for natural gas water heaters and parts." updated="October 2026">
        <PolicySection title="Who Ships Your Order">
          <p>
            Orders placed on AQUAFLAME are sold and fulfilled by Domain Technology (Hong Kong) Co., Limited.
          </p>
          <p>
            Company address: Man On Building, 18–20 Ho Man Tin Street, Kowloon City District, Kowloon, Hong Kong.
          </p>
          <p>
            If you have questions regarding order handling, you can contact us via email at{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a>.
          </p>
        </PolicySection>

        <PolicySection title="Where We Ship">
          <p>
            We ship physical goods across the United States.
          </p>
          <p>
            We do not offer international shipping at this time. Orders requesting delivery outside the United States cannot be fulfilled.
          </p>
        </PolicySection>

        <PolicySection title="Shipping Cost">
          <p>
            We provide flat-rate standard shipping on eligible items.
          </p>
          <p>
            The exact shipping amount is calculated and displayed clearly at checkout before you confirm payment.
          </p>
        </PolicySection>

        <PolicySection title="Processing and Delivery">
          <p>
            Orders are processed after payment is confirmed.
          </p>
          <p>
            The estimated delivery time is confirmed by email after the order is placed.
          </p>
          <p>
            Large items such as residential water heaters may be delivered by freight carrier. Freight deliveries require an adult present at the delivery address to inspect and sign for the shipment upon arrival.
          </p>
        </PolicySection>

        <PolicySection title="Tracking Information">
          <p>
            We email tracking information when available once your shipment is dispatched with the carrier. You can use the provided tracking reference to monitor the progress of your shipment.
          </p>
        </PolicySection>

        <PolicySection title="Inspect on Delivery">
          <p>
            Please inspect all packages and products carefully upon receipt before signing the carrier delivery receipt.
          </p>
          <p>
            If you notice any visible damage to the packaging or equipment, note the details directly on the carrier&apos;s delivery receipt and contact us by email with clear photos within 14 days of delivery.
          </p>
          <p>
            For information regarding returns of eligible unopened and unused items, please review our{" "}
            <Link to="/ReturnsPage">Returns Policy</Link>.
          </p>
        </PolicySection>

        <PolicySection title="Contact Us">
          <p>
            For questions about your shipment or delivery status, please email us at{" "}
            <a href="mailto:carry6891@outlook.com">carry6891@outlook.com</a>.
          </p>
          <p>
            We reply to emails within 1–2 business days.
          </p>
        </PolicySection>
      </PolicyLayout>
      <Footer />
    </div>;
}